export const movementTypeOptions = [
  { key: 'Normal', value: 'Normal', text: 'Normal' },
  { key: 'Immediate', value: 'Immediate', text: 'Immediate' },
];
